<template>
  <div class="h-full">
    <el-input
      size="small"
      :placeholder="placeholder"
      :value="name"
      :disabled="disabled"
      clearable
      @clear="clearName"
      @close="showDialog = false"
    >
      <template slot="append">
        <el-button size="small" :disabled="disabled" @click="showDialog = true">选择</el-button>
      </template>
    </el-input>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="选择风险点"
      :visible.sync="showDialog"
      width="1280px"
      top="2vh"
      class="large-dialog"
      v-dialogDrag
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="设备设施类" name="equipmentList">
          <!-- <el-badge slot="label" :value="equipCount" :max="99" :hidden="false">
            设备设施类
          </el-badge> -->
          <equip-point-table
            v-if="showDialog"
            ref="equipmentList"
            :multiple="multiple"
            :id="id"
            :name="name"
          ></equip-point-table>
        </el-tab-pane>
        <!-- <el-badge slot="label" :value="jobCount" :max="99" :hidden="false">
          作业活动类
        </el-badge> -->
        <el-tab-pane label="作业活动类" name="jobList">
          <job-point-table
            v-if="showDialog"
            ref="jobList"
            :multiple="multiple"
            :id="id"
            :name="name"
            @handleOk="handleOk"
          ></job-point-table>
        </el-tab-pane>

        <el-tab-pane label="基础管理类" name="baseList">
          <base-point-table
            v-if="showDialog"
            ref="baseList"
            :multiple="multiple"
            :id="id"
            :name="name"
            @handleOk="handleOk"
          ></base-point-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="text-center" v-if="multiple">
        <el-button type="primary" size="small" @click="handleOk" icon="iconfont icon-save">
          <span>确定</span>
        </el-button>
        <el-button size="small" @click="showDialog = false" icon="iconfont icon-close">
          <span>取消</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import EquipPointTable from './TableList/EquipPointTable'
import JobPointTable from './TableList/JobPointTable'
import BasePointTable from './TableList/BasePointTable'

export default {
  name: 'point-select',
  components: {
    EquipPointTable,
    JobPointTable,
    BasePointTable,
  },
  props: {
    id: String,
    name: String,
    placeholder: {
      type: String,
      default: '请选择风险点',
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeName: 'equipmentList',
      showDialog: false,

      equipCount: 0,
      jobCount: 0,
    }
  },
  computed: {},
  watch: {
    activeName(value) {
      this.$nextTick(() => {
        this.$refs[value].$refs.table.doLayout()
      })
    },
    immediate: true,
    deep: true,
  },
  created() {},
  methods: {
    clearName() {
      this.$emit('update:id', '')
      this.$emit('update:name', '')
    },
    handleOk() {
      const equipList = this.$refs.equipmentList.selectionData
      const jobList = this.$refs.jobList.selectionData
      const baseList = this.$refs.baseList.selectionData
      const allList = [...equipList, ...jobList, ...baseList].reduce((pre, item) => {
        const preItem = pre.find((i) => {
          return i.id === item.id
        })
        if (!preItem) {
          pre.push(item)
        }
        return pre
      }, [])
      const ids = allList
        .map((i) => {
          return i.id
        })
        .join(',')
      const names = allList
        .map((i) => {
          return i.name || i.jobName || i.screeningItemsName
        })
        .join(',')
      this.$emit('update:id', ids)
      this.$emit('update:name', names)
      this.$emit('getPointList', [...equipList, ...jobList, ...baseList])
      this.showDialog = false
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-tabs {
  height: 100%;
  .el-tabs__content {
    height: calc(100% - 34px);
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
